import styled from 'styled-components'

import { device, variables } from 'src/Styled/variables'

export const Wrapper = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  @media ${device.largeScreen} {
    flex: 0 0 50%;
    max-width: 50%;
  }
`
export const RowWrapper = styled.div`
  padding: 0;
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  flex-wrap: wrap;
  row-gap: 24px;
`

export const FormGroup = styled.div`
  width: 100%;
  position: relative;
`

export const RedText = styled.p`
  color: ${({ theme }) => theme.color.mediumRed};
`

export const DateFieldWrapper = styled.div<{ $isError?: boolean }>`
  width: 100%;

  .date-picker {
    width: 100%;
    border-radius: 16px;
    padding: 16px;
    background-color: ${({ theme }) => theme.color.white};
    border: 1px solid
      ${({ theme, $isError }) =>
        $isError ? theme.color.mediumRed : theme.color.lightGrey};
  }

  .date-picker.date-picker-focused {
    box-shadow: none;
    border-color: ${({ theme, $isError }) =>
      $isError ? theme.color.mediumRed : theme.color.brandGreen};
  }

  .date-picker .date-picker-input > input {
    color: ${({ theme }) => theme.color.darkGrey};
    font-family: 'Segoe UI';
    font-size: ${variables.fontSize14};
    font-weight: ${variables.fontWeight400};
    line-height: 150%;
  }

  .date-picker .date-picker-input > input::placeholder {
    color: ${({ theme }) => theme.color.slateGrey};
  }
`

export const ErrorText = styled.div`
  font-family: 'Segoe UI';
  color: ${({ theme }) => theme.color.mediumRed};
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  margin-top: 5px;
`

export const Form = styled.form`
  max-width: 2000px;
  margin-top: 0;
  display: flex;
  flex-wrap: wrap;
`
export const ButtonWrapper = styled.div`
  flex: 0 0 100%;
  max-width: 100%;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 16px;
  div {
    width: fit-content;
    .ant-btn.ant-btn-default {
      padding: 0 40px;
    }
  }
`
